import React, { useContext } from "react";
import { useState } from "react";
import "../../css_files/Master/AddGSTMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";

function AddGSTMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  gstupdatedata,
}) {
  const [gstData, setGstData] = useState({
    Rate: triggerupdate ? gstupdatedata?.rate : "",
    Description: triggerupdate ? gstupdatedata?.description : "",
  });
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const { setExpiredSession } = useContext(triggerscroll);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/GST/UpdateGST`;
      axiosInstance
        .post(url, {
          id: gstupdatedata.id,
          rate: gstData.Rate,
          description: gstData.Description,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(err);
          setloading(false);
        });
    } else {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/gst`;
      axiosInstance
        .post(URL, gstData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error("Error adding packing data:", error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }
  return (
    <form className="add-gst-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Rate{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter GST Rate (in percentage)"
          value={gstData.Rate}
          onChange={(e) => setGstData({ ...gstData, Rate: e.target.value })}
          onInput={(e) => {
            e.target.value = e.target.value
              .replace(/[^0-9.]/g, "")
              .replace(/^(\d{2})\d*/, "$1")
              .replace(/(\.\d{2}).*/, "$1")
              .replace(/(\..*)\./g, "$1");
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/GST/GetGSTByRate?rate=${e.target.value}`
              )
              .then(() => setMessage("GST With this rate Already Exists"))
              .catch((error) => {
                setMessage("");
              });
          }}
          required
        />
        <span style={{ color: "red" }}>{message}</span>
      </blockquote>
      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter Description (Maximum 400 Characters)"
          value={gstData.Description}
          onChange={(e) =>
            setGstData({ ...gstData, Description: e.target.value })
          }
          onInput={(e) => (e.target.value = e.target.value.slice(0, 400))}
        ></textarea>
      </blockquote>
      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddGSTMaster;
